import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { NotificationManager } from 'react-notifications'
import debounce from 'lodash/debounce';
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'

// Download order Excel Action  
export const dowloadOrderActionss = (id) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.DOWNLOAD_ORDER+"/"+id;
    let options = {
      method: HTTP_METHOD.GET,
      headers: getHeaders(),
      url: url
    };
    return axiosInstance(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
          dispatch({ type: types.GET_DOWNLOAD_ORDER, payload: resp })
        return resp.blob();
      } else { return null } })
      .catch(error => {
        errorHandler(error)
    })
  }

  export const dowloadOrderAction = (id) => async (dispatch) => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = `${API_URL}${Url.DOWNLOAD_ORDER}/${id}`;
    const headers = getHeaders();
  
    try {
      const response = await axiosInstance.get(url, {
        headers,
        responseType: 'blob',
      });
  
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('Failed to download file');
      }
    } catch (error) {
      NotificationManager.error(error.message || 'Error downloading file');
      throw error;
    }
  };

// Download Part Excel Action  

export const dowloadPartsAction = () => async (dispatch) => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.DOWNLOAD_PARTS;
  const headers = getHeaders();

  try {
    const response = await axiosInstance.get(url, {
      headers,
      responseType: 'blob',
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to download file');
    }
  } catch (error) {
    NotificationManager.error(error.message || 'Error downloading file');
    throw error;
  }
};

// Download Order Excel Action with Date Range

export const downloadOrderWithDateRangeAction = (startDate, endDate) => async (dispatch) => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.DOWNLOAD_ORDER_DATE_RANGE + `?start_date=${startDate}&end_date=${endDate}`;
  const headers = getHeaders();

  const showErrorNotification = debounce((message) => {
    NotificationManager.error(message);
  }, 1000, { leading: true, trailing: false });

  try {
    const response = await axiosInstance.get(url, {
      headers,
      responseType: 'blob',
      validateStatus: function (status) {
        return true; 
      },
    });

    if (response?.status === 200) {
      const blob = new Blob([response?.data], { type: response?.data.type });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `orders_${startDate}_to_${endDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      dispatch({ type: types.GET_DOWNLOAD_ORDER, payload: response });
    } else {
      const errorBlob = response.data;
      const errorText = await errorBlob.text();
      const errorJson = JSON.parse(errorText);

      const errorMessage = errorJson?.message;      
      showErrorNotification(errorMessage);
    }
  } catch (error) {
    showErrorNotification(error.message || 'Unexpected error occurred');
    throw error;
  }
};

export const downloadPartnerAction = (activeStatus, selectedExecutiveId) => async (dispatch) => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  let url = `${API_URL}${Url.DOWNLOAD_PARTNER}?status=${activeStatus}`;

  if (selectedExecutiveId) {
    url += `&area_executive_id=${selectedExecutiveId}`;
  }
  const headers = getHeaders();

  try {
    const response = await axiosInstance.get(url, {
      headers,
      responseType: 'blob',
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to download file');
    }
  } catch (error) {
    NotificationManager.error(error.message || 'Error downloading file');
    throw error;
  }
};

export const downloadNotificationExcelAction = (filters = {}) => async (dispatch) => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const queryParams = new URLSearchParams(filters).toString();
  const url = `${API_URL}${Url.DOWNLOAD_NOTIFICATION_EXCEL}?${queryParams}`;
  const headers = getHeaders();

  try {
    const response = await axiosInstance.get(url, {
      headers,
      responseType: 'blob',
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to download file');
    }
  } catch (error) {
    NotificationManager.error(error.message || 'Error downloading file');
    throw error;
  }
};